
import { accountStore } from "./AccountStore";
import { categoryStore } from "./CategoryStore";
import { customerStore } from "./CustomerStore";
import { epicTypeStore } from "./EpicTypeStore";
import { invoicePaymentTypeStore } from "./InvoicePaymentTypeStore";
import { locationStore } from "./LocationStore";
import { netSuitePaymentTypeStore } from "./NetSuitePaymentTypeStore";
import { payTypeStore } from "./PayTypeStore";
import { splitStore } from "./SplitStore";
import { vendorStore } from "./VendorStore";

export const FETCH_MESSAGE = 'Click Show Data to retrieve data for the selected date range';

export async function loadReferenceData() {
	const { userStore } = await import('./UserStore');
	// Dynamic import to avoid circular dependency with UserStore

	await accountStore.loadData();
	await splitStore.loadData();
	await categoryStore.loadData();
	await customerStore.loadData();
	await locationStore.loadData();
	await userStore.loadDirectory();
	await vendorStore.loadData();
	await invoicePaymentTypeStore.loadData();
}

export async function loadProjectInvoiceData() {
	await accountStore.loadData();
	await splitStore.loadData();
	await categoryStore.loadData();
	await customerStore.loadData();
	await payTypeStore.loadData();
	await epicTypeStore.loadData();
	await netSuitePaymentTypeStore.loadData();
}

function isEntityActive<T extends { id: string; isActive?: boolean }>(data: T[], id: string): boolean {
	return data.find(e => e.id === id)?.isActive ?? false;
}

export function isAccountActive(accountId: string): boolean {
	return isEntityActive(accountStore.data, accountId);
}
export function isSplitActive(splitId: string): boolean {
	return isEntityActive(splitStore.data, splitId);
}
export function isCategoryActive(categoryId: string): boolean {
	return isEntityActive(categoryStore.data, categoryId);
}
export function isCustomerActive(customerId: string): boolean {
	return isEntityActive(customerStore.data, customerId);
}
export function isLocationActive(locationId: string): boolean {
	return isEntityActive(locationStore.data, locationId);
}
export function isVendorActive(vendorId: string): boolean {
	return isEntityActive(vendorStore.data, vendorId);
}

export const getAccount = (accountId: string) => accountStore.data.find(i => i.id === accountId)?.name ?? accountId;
export const getCategory = (categoryId: string) => categoryStore.data.find(i => i.id === categoryId)?.name ?? categoryId;
export const getCustomer = (customerId: string) => customerStore.data.find(i => i.id === customerId)?.name ?? customerId;
export const getSplit = (splitId: string) => splitStore.data.find(i => i.id === splitId)?.name ?? splitId;
export const getEpicType = (epicTypeId?: number) => epicTypeStore.data.find(i => i.id === epicTypeId)?.name ?? epicTypeId;
export const getPayType = (payTypeId?: number) => payTypeStore.data.find(i => i.id === payTypeId)?.name ?? payTypeId;
export const getNSPayType = (nsPayTypeId?: number) => netSuitePaymentTypeStore.data.find(i => i.id === nsPayTypeId)?.name ?? nsPayTypeId;
export const getVendor = (vendorId: string) => vendorStore.data.find(i => i.id === vendorId)?.name ?? vendorId;
export const getLocation = (locationId: string) => locationStore.data.find(i => i.id === locationId)?.name ?? locationId;
